import { render } from "./BaseTicket.vue?vue&type=template&id=3e3ea252&scoped=true"
import script from "./BaseTicket.vue?vue&type=script&lang=js"
export * from "./BaseTicket.vue?vue&type=script&lang=js"

import "./BaseTicket.vue?vue&type=style&index=0&id=3e3ea252&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3e3ea252"
/* hot reload */
if (module.hot) {
  script.__hmrId = "3e3ea252"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e3ea252', script)) {
    api.reload('3e3ea252', script)
  }
  
  module.hot.accept("./BaseTicket.vue?vue&type=template&id=3e3ea252&scoped=true", () => {
    api.rerender('3e3ea252', render)
  })

}

script.__file = "src/ui/tickets/BaseTicket.vue"

export default script